import { getContentEnvHost } from './environment';
import type { Env } from './types';

export const CONTENT_HOST = 'https://scontent01';

const CDN_PATH = 'cdn';
const MEDIA_PATH = 'media';

const staticContentHosts = {
  CANCEL_SUBSCRIPTION_CONTENT_URL: `cancel-subscription/${CDN_PATH}`,
  CUSTOMIZE_CONTENT_URL: `customize/${CDN_PATH}`,
  GIFTING_CONTENT_URL: `gifting/${CDN_PATH}`,
  GIFTING_MEDIA_CONTENT_URL: `gifting/${CDN_PATH}/${MEDIA_PATH}`,
  GTB_CONTENT_URL: `gtb/${CDN_PATH}`,
  GTB_THANK_YOU_CONTENT_URL: `gtb-thank-you/${CDN_PATH}`,
  HOMEPAGE_CONTENT_URL: `homepage/${CDN_PATH}`,
  MY_ACCOUNT_MEDIA_CONTENT_URL: `my-account/${CDN_PATH}/${MEDIA_PATH}`,
  PANDORA_CONTENT_URL: `pandora/${CDN_PATH}`,
  PERSONAL_SURVEY_CONTENT_URL: `personal-survey/${CDN_PATH}`,
  PLUTUS_CONTENT_URL: `plutus/${CDN_PATH}`,
  RATINGS_AND_REVIEWS_CONTENT_URL: `ratings-and-reviews/${CDN_PATH}`,
  REFERRALS_CONTENT_URL: `referrals/${CDN_PATH}`,
  REFERRALS_MEDIA_CONTENT_URL: `referrals/${CDN_PATH}/${MEDIA_PATH}`,
};

type StaticContentHosts = keyof typeof staticContentHosts;

/**
 * Retrieve the available Content urls for the given environment.
 * @description
 * This function takes the environment as parameter and returns
 * the Content urls for the given environment. It also takes an
 * optional parameter to select the API Hosts to return in
 * cases where just a few are needed.
 */
export function getStaticContentUrls(env: Env, select?: StaticContentHosts[]) {
  const apiEnvHost = getContentEnvHost(env);

  return Object.entries(staticContentHosts).reduce(
    (acc, [key, value]) => {
      const typedKey = key as StaticContentHosts;

      if (select && !select.includes(typedKey)) {
        return acc;
      }

      acc[typedKey] = `${CONTENT_HOST}.${apiEnvHost}/${value}`;
      return acc;
    },
    {} as Record<StaticContentHosts, string>,
  );
}
